
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getCards() {
        const url = `${API_URL}/analytics/cards`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getYear(params = {}) {
        const url = `${API_URL}/analytics/year-performance`;
        return axios.get(url, { params, headers: authHeader() });
    },
    getUndelivered() {
        const url = `${API_URL}/analytics/undelivered`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getUnvalidate() {
        const url = `${API_URL}/analytics/unvalidated`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getProduction() {
        const url = `${API_URL}/analytics/production`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getReportProductionUser(data) {
        return axios.post(`${API_URL}/export/production-user`, data, { 
            headers: {
                ...authHeader(), 
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
            responseType: 'blob', 
        });
    },
    getReportProductionReport(data = {}) {
        return axios.post(`${API_URL}/export/production-report`, data, {
            headers: {
                ...authHeader(),
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
            responseType: 'blob',
        });
    },
    getReportCargueReport(data = {}) {
        return axios.post(`${API_URL}/export/cargue-report`, data, {
            headers: {
                ...authHeader(),
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
            responseType: 'blob',
        });
    },
    getAverias(data) {
        const url = `${API_URL}/analytics/averias`; 
        return axios.get(url, { 
            headers: authHeader(),
            params: data 
        });
    },
    getTerminados(data) {
        const url = `${API_URL}/analytics/totalesTerminadosPorProducto`; 
        return axios.get(url, { 
            headers: authHeader(),
            params: data 
        });
    },
    getInformeExtrusion(data) {
        const url = `${API_URL}/analytics/informeExtrusion`; 
        return axios.get(url, { 
            headers: authHeader(),
            params: data 
        });
    },

    getInformeHornos(data) {
        const url = `${API_URL}/analytics/informeHornos`; 
        return axios.get(url, { 
            headers: authHeader(),
            params: data 
        });
    },
    
};